import { InjectionToken } from '@angular/core';

export const WHITELISTED_ERROR_CODES = new InjectionToken<number[]>('WHITELISTED_ERROR_CODES');
